<mat-card-content>
  <div class="d-flex justify-content-between">
    <mat-card-title>Aviso</mat-card-title>
    <span mat-dialog-close><mat-icon>close</mat-icon></span>
  </div>
  <mat-divider></mat-divider>

  <div class="row gy-3 mb-0">
    <div class="col-12 text-center py-3">
      <i class="fa-light fa-circle-exclamation fa-6x"></i>
      <div class="mt-4">
        <p class="mb-0">{{msg}}</p>
      </div>
    </div>
  </div>

  <mat-divider></mat-divider>

  <div class="d-flex justify-content-end">
    <button mat-stroked-button class="me-3" *ngIf="showAll == true" color="alternative" (click)="cancelar()">Cancelar</button>
    <button mat-flat-button color="success" (click)="aceptar()">Aceptar</button>
  </div>
</mat-card-content>
